import PropTypes from 'prop-types';
import React from 'react';
import {
  Badge,
} from 'react-bootstrap';
import { findById } from '../../../core/utils';
import TourRosterGroups from './TourRosterGroups';
import TourRosterToolbar from './TourRosterToolbar';
import TourRosterTable from './TourRosterTable';
import MemberDetailModal from './MemberDetailModal';
import ImportRosterModal from './ImportRosterModal';
import GroupDetailModal from './GroupDetailModal';
import DefineGroups from './DefineGroups';
import TourHotelRouteList from './TourHotelRouteList';
import GroupsHotelPickerContainer from './GroupsHotelPickerContainer';

function findEvent(value) {
  // do not use === here, matches a string and a number
  return value.id == this; // eslint-disable-line
}

class TourRosterTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showImport: false,
      showaddGroup: false,
      event: null,
    };
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleShowMember = this.handleShowMember.bind(this);
    this.handleShowImport = this.handleShowImport.bind(this);
    this.closeImport = this.closeImport.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleShowGroup = this.handleShowGroup.bind(this);
    this.handleCloseGroup = this.handleCloseGroup.bind(this);
    this.setCurrentEvent = this.setCurrentEvent.bind(this);
  }
  componentWillMount() {
    //console.log('In TourRosterTab.componentWillMount() ');
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedEvent !== this.props.selectEvent) {
      const event = nextProps.tour.tour_stops.find(findEvent, nextProps.selectedEvent);
      this.setState({ event });
    }
  }
  setCurrentEvent(id) {
    this.props.selectEvent(id);
  }
  closeModal() {
    this.setState({
      show: false,
    });
  }
  closeImport() {
    this.setState({
      showImport: false,
    });
  }
  handleRemoveMember(e) {
    //console.log('in handleRemoveMember ');
    const id = e.currentTarget.getAttribute('data-item');
    e.preventDefault();
    if (id) {
      const member = this.findUser(id);
      console.log('remove user from group: ', id, member.group.id);
      this.props.dispatchRemoveMemberFromGroup(member.group.id, id);
      // this.props.removeUserFromGroup(id, group.id);
    }
  }
  handleShowImport(e) {
    e.preventDefault();
    this.setState({
      showImport: true,
    });
  }
  handleShowGroup(){
    //console.log('called handleShowGroup')
    this.setState({showaddGroup:true})
  }
  handleCloseGroup(){
    this.setState({showaddGroup:false})
  }
  handleShowMember(e) {
    e.preventDefault();
    //console.log('handleShowMember: select user');
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      //console.log('show user: ', id);
      this.setState({
        user: id,
        show: true,
      });
    } else {
      //console.log('show add user!');
      this.setState({
        user: -1,
        show: true,
      });
    }
  }
  findUser(id) {
    const idx = this.props.tour.members.findIndex(findById, id);
    if (idx === -1) {
      console.log('that should not happen... findUser: ', id);
      return {};
    }
    return this.props.tour.members[idx];
  }
  

  render() {
    let group = {name:'test group'}
    return (
      <div className="col-sm-12 planner">
        <div className="roster-groups">
          {/* <TourRosterGroups
            groups={this.props.tour.groups}
            removeGroup={this.props.removeGroup}
            editGroup={this.props.editGroup}
            readOnly={this.props.readOnly}
            addMember={this.props.addMember}
          /> */}
          <DefineGroups
            totalvalue={this.props} 
            tour={this.props.tour}
            groups={this.props.tour.groups}
            removeGroup={this.props.removeGroup}
            editGroup={this.props.editGroup}
            newGroup={this.props.newGroup}
            createQuestions={this.props.createQuestions}
            addedQuestion={this.props.addedQuestion}
            addQuestion={this.props.addQuestion}
            removeQuestion={this.props.removeQuestion}
            requestTourquestions={this.props.requestTourquestions}
            newRoomType={this.props.newRoomType}
            addMultipleBidDetail={this.props.addMultipleBidDetail}
            saveRoomPreferences={this.props.saveRoomPreferences}
          />
          {/* <TourRosterToolbar
            tour={this.props.tour}
            newGroup={this.props.newGroup}
            importRoster={this.props.importRoster}
            handleAddMember={this.handleShowMember}
            handleShowImport={this.handleShowImport}
            readOnly={this.props.readOnly}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            handleAddGroup={this.handleShowGroup}
          /> */}

        </div> 
        <div className="members-groups">
          {/* <h3>Members <Badge>{this.props.tour.members.length}</Badge></h3>
          <TourRosterTable
            members={this.props.tour.members}
            handleRemoveMember={this.handleRemoveMember}
            handleEditMember={this.handleShowMember}
            editMember={this.props.editMember}
            editGroup={this.props.editGroup}
            readOnly={this.props.readOnly}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            groups={this.props.tour.groups}
            addMember={this.props.addMember}
            group_bid_data={this.props.tour.group_bid_data}
            postGroupData={this.props.postGroupData}
            bulkPostGroupData={this.props.bulkPostGroupData}
            tourId={this.props.tour.id}
            memberData={this.findUser(this.state.user)}
            user ={this.state.user}
            isLoading ={this.props.isLoading}
          />
          { this.state.showImport && (
            <ImportRosterModal
              tourId={this.props.tour.id}
              importRoster={this.props.importRoster}
              onClose={this.closeImport}
              show={this.state.showImport}
            />
          )}
          { this.state.show && (
            <MemberDetailModal
              tourId={this.props.tour.id}
              member={this.findUser(this.state.user)}
              show={this.state.show}
              onClose={this.closeModal}
              addMember={this.props.addMember}
              editMember={this.props.editMember}
              groups={this.props.tour.groups}
              readOnly={this.props.readOnly}
              dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            />
          )} */}
          { this.state.showaddGroup && (
        <GroupDetailModal
          group={group}
          groups={this.props.tour.groups}
          show={this.state.showaddGroup}
          onClose={this.handleCloseGroup}
          editGroup={this.props.editGroup}
          editing={true}
          addGroup={true}
          tour_id={this.props.tour.id}
          newGroup={this.props.newGroup}
        />
        )}
        </div>
      </div>
    );
  }
}
TourRosterTab.propTypes = {
  tour: PropTypes.object.isRequired,
  newGroup: PropTypes.func.isRequired,
  removeGroup: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
  addMember: PropTypes.func.isRequired,
  editMember: PropTypes.func.isRequired,
  importRoster: PropTypes.func.isRequired,
  dispatchRemoveMemberFromGroup: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
TourRosterTab.defaultProps = {
  readOnly: false,
};
export default TourRosterTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTab.js